import React, { Component } from "react";
import { connect } from "@common/components/base.component";
import consultarProtocoloSelector from "../store/consultarProtocolo.selectors";
import consultarProtocoloActions from "../store/consultarProtocolo.actions";
import autoBind from "react-autobind";
import StaticGrid from "@common/components/grid/staticGrid.component";
import * as typeArray from "@/modules/common/app/helpers/grid.typeArray";
import Button from '@material-ui/core/Button';

class Container extends Component {
  constructor(props) {
    super(props);
    autoBind(this);

    const options = {
      filterVersion: Math.random(),
      noStorage: true,
      webStorage: "RedeSIM.ConsultarProtocolo.Solicitante",
      applySearchOnLoad: true,
      isNotCheckable: true,
    };

    const columns = [
      {
        fieldName: "Protocolo",
        dataName: "NumeroProtocolo",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Cnpj",
        dataName: "CnpjEmpresa",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Nome Empresa",
        dataName: "NomeEmpresa",
        show: true,
        type: "text",
        removeFilter: true
      },
      {
        fieldName: "Ccm",
        dataName: "Ccm",
        show: true,
        type: "number",
        removeFilter: true
      },
    ];

    const actions = [
      {
        title: "Consultar Procotolo",
        icon: "fas fa-check",
        onClick: async dataItem => {
          this.props.consultarProtocoloActions.abrirConsultarProtocolo(dataItem);
        }
      }
    ];

    const order = [
      { fieldName: "Protocolo", dataName: "Protocolo", order: "A" }
    ];

    const toolbar = {
      title: "",
      prefix: " ",
      tools: {
        limpar: false
      }
    };

    this.config = {
      order,
      columns,
      actions,
      options,
      toolbar
    };
  }

  onClose(){
    this.props.consultarProtocoloActions.setConsultarProtocoloGridPesquisa([]);
    this.props.consultarProtocoloActions.setGridConsultarProtocolo([]);
  }

  render() {
    const { consultarProtocolo } = this.props.consultarProtocoloSelector;
    const { GridConsultarProtocoloPesquisa } = consultarProtocolo;

    return (
      <>
      <StaticGrid {...this.config} itens={GridConsultarProtocoloPesquisa.asMutable()}></StaticGrid>
        <div style={{ textAlign: 'right' }}>
          <Button variant="outlined" color="primary" onClick={this.onClose}>
                    <i className={"mr-1 fa fa-angle-double-left"} />{" "}
                    {"Voltar"}
          </Button>
        </div>
      </>
    );
  }
}

export default connect({
  actions: {
    consultarProtocoloActions
  },
  selectors: {
    consultarProtocoloSelector
  }
})(Container);
